import { createFileRoute } from '@tanstack/react-router'
import { AuditorRisksPage, auditorRiskSearchSchema } from '@/components/auditor-center/AuditorRisksPage'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/risks',
)({
  validateSearch: auditorRiskSearchSchema,
  component: AuditorRisksPage,
})
